import { IconKey ,IconAd} from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconAd
};
//

const Marketing = {

    id: 'marketing',
    title: 'Marketing',
    type: 'group',
    display_id:'O',
    icon: icons.IconAd,
    children: [
        {
            id: 'marketing_dashboard_ratna',
            title: 'Ratna',
            type: 'item',
            display_id:49,
            url: '/Department/Marketing/ratna',
            breadcrumbs: false
        },
        {
            id: 'marketing_dashboard_code_activation',
            title: 'Code Activation',
            type: 'item',
            display_id:59,
            url: '/Department/Marketing/code_activation',
            breadcrumbs: false
        },
        {
            id: 'marketing_dashboard_mandate',
            title: 'Mandate',
            type: 'item',
            display_id:60,
            url: '/Department/Marketing/mandate',
            breadcrumbs: false
        },
        {
            id: 'marketing_dashboard_network',
            title: 'Network',
            type: 'item',
            display_id:61,
            url: '/Department/Marketing/Network',
            breadcrumbs: false
        },
    ]
}

export default Marketing;